export default function AppAdsTxt() {
    return (
        <pre>
            google.com, pub-2925749804639554, DIRECT, f08c47fec0942fa0
        </pre>
    );
}